import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$4 } from './prism-icon2.js';
import { d as defineCustomElement$3 } from './prism-icon-button2.js';
import { d as defineCustomElement$2 } from './prism-input2.js';

const prismSelectCss = ":host{display:block}";
const PrismSelectStyle0 = prismSelectCss;

const sharedCss = ".prism-headline-mega{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20);text-transform:uppercase;}.prism-headline-mega-inlined{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-90);text-transform:uppercase;}.prism-headline-2xl{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-2xl-inlined{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-xl{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-xl-inlined{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-large{font-size:var(--prism-typography-global-type-scale-step5);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30)}.prism-headline-medium{font-size:var(--prism-typography-global-type-scale-step4);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-small{font-size:var(--prism-typography-global-type-scale-step3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-headline-xs{font-size:var(--prism-typography-global-type-scale-step2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-subtitle-1{font-size:var(--prism-typography-global-type-scale-step1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-subtitle-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-1,body{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-large);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-button,button{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100)}.prism-caption,caption,figcaption{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-overline{font-size:var(--prism-typography-global-type-scale-step-2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-larger);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.prism-microlabel{font-size:var(--prism-typography-global-type-scale-step-3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-largest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.pwc-none{display:none}.pwc-visually-hidden{border:0;height:0;margin:0;padding:0;outline:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;appearance:none}.pwc-input-label{position:absolute;left:0;top:50%;transform:translateY(-50%);transition:0.1s ease-out;transform-origin:left top;pointer-events:none}.pwc-input{outline:none;background-color:transparent;color:var(--prism-color-theme-ink);padding:var(--prism-spacing-global-small) 0;width:100%}";
const PrismSelectStyle1 = sharedCss;

const PrismSelect$1 = /*@__PURE__*/ proxyCustomElement(class PrismSelect extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.valueChange = createEvent(this, "valueChange", 7);
        this.internals = this.attachInternals();
        // Reference to the menu items' values.
        this.selectValues = [];
        this.placement = 'bottom-start';
        this.visible = false;
        this.value = undefined;
        this.editable = false;
        this.disabled = false;
    }
    watchValue(value) {
        // Update input's value on value change.
        this.input.value = value;
        this.internals.setFormValue(value);
        this.valueChange.emit(value);
        this.input.focus();
    }
    /** Listener for the menu's visibility changes. */
    handleMenuVisibleChange(event) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (event.target.tagName.toLowerCase() === 'prism-menu') {
            this.visible = event.detail;
            this.input.isMenuOpen = event.detail;
            if (this.visible) {
                // Set the menu base's width to match input's width.
                (_a = this.menuBase) === null || _a === void 0 ? void 0 : _a.style.setProperty('width', `${this.input.clientWidth}px`);
            }
        }
    }
    /**
     * Listener for the 'valueInput' event from the prism-input.
     */
    handleValueInput(event) {
        if (
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event.target.tagName.toLowerCase() === 'prism-input') {
            if (!this.menu.visible && event.detail !== this.value) {
                // If the menu is not visible and the user starts typing we should open the menu.
                this.menu.visible = true;
            }
            // Find a menu item, which value matches user's input.
            // This only works when the editable is true. Otherwise, finding the match
            // is handled by the menu-base component.
            this.match = this.menuItems.find((item) => { var _a, _b; return (_a = item.value) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith((_b = event.detail) === null || _b === void 0 ? void 0 : _b.toLowerCase()); });
            if (this.match) {
                // Make the matched menu item active
                this.match.active = true;
            }
            else {
                // Remove the active property when there's no match
                if (this.activeMenuItem) {
                    this.activeMenuItem.active = false;
                }
            }
        }
    }
    /**
     * Listener for the 'valueChange' event.
     */
    handleValueChange(event) {
        var _a, _b;
        if (
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event.target.tagName.toLowerCase() === 'prism-menu') {
            // Assign the selected menu item's value to the component's value
            this.value = event.detail;
            (_a = this.menuItems) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                // Mark the selected menu item.
                item.selected = item.value === this.menu.value;
            });
        }
        else if (
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event.target.tagName.toLowerCase() === 'prism-input') {
            if (!this.selectValues.includes(event.detail)) {
                // Assign the user's value to the component's value, if it is not one of the select values
                this.value = event.detail;
                (_b = this.menuItems) === null || _b === void 0 ? void 0 : _b.forEach((item) => {
                    // Deselect menu items
                    item.selected = false;
                });
            }
        }
    }
    /** Listener for the keydown event. */
    handleKeyDown(event) {
        // Find the active menu item.
        this.activeMenuItem = this.menuItems.find((item) => item.active);
        let eventHandled = true;
        switch (event.key) {
            case 'Enter':
                this.handleEnterKeyPress(event);
                break;
            case 'ArrowDown':
                this.handleArrowDownKeyPress();
                break;
            case 'ArrowUp':
                this.handleArrowUpKeyPress();
                break;
            default:
                eventHandled = false;
        }
        if (eventHandled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Sets a default form value. */
    formAssociatedCallback() {
        this.internals.setFormValue(this.value);
    }
    render() {
        return (h("div", { key: '94d7bfcf41112503cd1a8ad21f34d4ae1a1fe009' }, h("prism-input", { key: '501022339ff6dce1299776f13bc9b836df2437ad', role: "combobox", value: this.value, readonly: !this.editable, disabled: this.disabled, ref: (el) => (this.input = el), slot: "menu-trigger" }, h("button", { key: '65674008af795385b4a5761e32d391a35aec6858', disabled: this.disabled, "aria-label": "Click to toggle select's options", slot: "icon-end", style: { ['border']: 'none', ['background']: 'transparent', ['padding']: '0' } }, h("prism-icon", { key: '61adc656338f351066b4881bece7ae2efb266944', icon: "arrow_drop_down", style: {
                ['color']: this.visible
                    ? 'var(--prism-color-theme-accent-primary)'
                    : this.disabled
                        ? 'var(--prism-color-theme-disabled-contrast)'
                        : 'var(--prism-color-theme-base-contrast)'
            } }))), h("slot", { key: 'c11b1ea77f3827188817e8311f8c3ff6be6a7be8', onSlotchange: (e) => this.slotChange(e) }), h("slot", { key: '380ad13729dabee06d804f633ce0ac2e7c4c4810', name: "label", onSlotchange: (e) => this.labelSlotChange(e) }), h("slot", { key: '7f7066fb0b151f812816a495931e415cda25246e', name: "help-text", onSlotchange: (e) => this.helpTextSlotChange(e) })));
    }
    /** Find and set up the menu element. */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    slotChange(event) {
        var _a;
        this.menu = [...event.target.assignedElements()].find((el) => el.nodeName === 'PRISM-MENU');
        // Insert the input as the menu trigger and the first child of the menu.
        (_a = this.menu) === null || _a === void 0 ? void 0 : _a.insertBefore(this.input, this.menu.firstChild);
        // Assign select's properties to menu properties.
        this.menu.placement = this.placement;
        this.menu.visible = this.visible;
        this.menu.value = this.value;
        this.menu.editableSelectMenu = this.editable;
        this.menuBase = this.menu.shadowRoot.querySelector('prism-menu-base');
        // Assign select's properties to menu base properties.
        this.menuBase.selectMenu = true;
        this.menuBase.editableSelectMenu = this.editable;
        // Find all the menu items.
        this.menuItems = [...this.menu.querySelectorAll('prism-menu-item')];
        this.menuItems.forEach((item) => {
            // Assign the menu items to the select's values.
            this.selectValues.push(item.value);
            // Assign the menu items selectMenuItem property to true.
            item.selectMenuItem = true;
            // Mark the selected menu item.
            item.selected = item.value === this.menu.value;
        });
    }
    /** Assign the slotted label to the input. */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelSlotChange(event) {
        var _a;
        const label = event.target.assignedElements()[0];
        if (label) {
            (_a = this.input) === null || _a === void 0 ? void 0 : _a.insertBefore(label, this.input.firstChild);
        }
    }
    /** Assign the slotted help text to the input. */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    helpTextSlotChange(event) {
        var _a;
        const helpText = event.target.assignedElements()[0];
        if (helpText) {
            (_a = this.input) === null || _a === void 0 ? void 0 : _a.insertBefore(helpText, this.input.firstChild);
        }
    }
    handleEnterKeyPress(event) {
        if (!this.menu.visible) {
            this.menu.visible = true;
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (this.match && this.match === this.activeMenuItem) {
            // Select matched menu item.
            this.match.click();
        }
        else if (!this.activeMenuItem) {
            // Blur the input and close the menu when submitting a value
            // outside of the select's items
            this.input.blur();
            this.menu.visible = false;
        }
        else if (this.activeMenuItem) {
            // Select the active menu item
            this.activeMenuItem.click();
        }
    }
    handleArrowDownKeyPress() {
        if (!this.menu.visible) {
            this.menu.visible = true;
        }
        else {
            // Dispatch the arrow down keydown event to the prism-menu-base to focus the next menu item
            const arrowDownEvent = new KeyboardEvent('keydown', { key: 'ArrowDown' });
            this.menuBase.dispatchEvent(arrowDownEvent);
        }
    }
    handleArrowUpKeyPress() {
        // Dispatch the arrow up keydown event to the prism-menu-base to focus the next menu item
        const arrowUpEvent = new KeyboardEvent('keydown', { key: 'ArrowUp' });
        this.menuBase.dispatchEvent(arrowUpEvent);
    }
    static get delegatesFocus() { return true; }
    static get formAssociated() { return true; }
    static get watchers() { return {
        "value": ["watchValue"]
    }; }
    static get style() { return PrismSelectStyle0 + PrismSelectStyle1; }
}, [81, "prism-select", {
        "placement": [1],
        "visible": [1028],
        "value": [1025],
        "editable": [4],
        "disabled": [1028]
    }, [[0, "visibleChange", "handleMenuVisibleChange"], [0, "valueInput", "handleValueInput"], [0, "valueChange", "handleValueChange"], [0, "keydown", "handleKeyDown"]], {
        "value": ["watchValue"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-select", "prism-icon", "prism-icon-button", "prism-input"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismSelect$1);
            }
            break;
        case "prism-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "prism-icon-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "prism-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PrismSelect = PrismSelect$1;
const defineCustomElement = defineCustomElement$1;

export { PrismSelect, defineCustomElement };

